var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Navigate, Route, Routes, useLocation, useNavigate, useSearchParams, } from "react-router-dom";
import { Layout } from "@stellar/design-system";
import { fetchTransaction } from "helpers/fetchTransaction";
import { Kyc } from "pages/Kyc";
import { NotFound } from "pages/NotFound";
import { Start } from "pages/Start";
import { Status } from "pages/Status";
import { Welcome } from "pages/Welcome";
import "./styles.scss";
import { TxnInfo } from "./pages/TxnInfo";
export var BUSINESS_SERVER_ENDPOINT = process.env.BUSINESS_SERVER_ENDPOINT;
export var App = function () {
    var _a;
    var navigate = useNavigate();
    var location = useLocation();
    var _b = useState(""), token = _b[0], setToken = _b[1];
    var _c = useState(""), sessionToken = _c[0], setSessionToken = _c[1];
    var _d = useState(), txnInfo = _d[0], setTxnInfo = _d[1];
    var searchParams = useSearchParams()[0];
    // Set token or session token in state
    useEffect(function () {
        setQueryParam();
    }, [location.search]);
    // Get session token from token
    useEffect(function () {
        if (token && !location.pathname.includes("txn")) {
            navigate({ pathname: "/start", search: location.search });
        }
    }, [token]);
    // Set session token if page refreshed
    useEffect(function () {
        if (sessionToken && !location.pathname.includes("txn")) {
            handleStartSession(sessionToken);
        }
    }, [sessionToken]);
    var setQueryParam = function () {
        var queryParams = new URLSearchParams(location.search);
        var token = queryParams.get("token");
        var sessionToken = queryParams.get("session_token");
        if (token) {
            setToken(token);
            setSessionToken("");
        }
        else if (sessionToken) {
            setToken("");
            setSessionToken(sessionToken);
        }
        else {
            // TODO: handle error
        }
    };
    var handleStartSession = function (sToken) { return __awaiter(void 0, void 0, void 0, function () {
        var txnInfo;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchTransaction(sToken)];
                case 1:
                    txnInfo = _a.sent();
                    setTxnInfo(txnInfo);
                    if (txnInfo.status === "incomplete") {
                        navigate({ pathname: "/kyc", search: "?session_token=".concat(sToken) });
                    }
                    else {
                        navigate({ pathname: "/status", search: "?session_token=".concat(sToken) });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleFinishTransaction = function (sToken) {
        navigate({ pathname: "/status", search: "?session_token=".concat(sToken) });
    };
    var ProtectedRoute = function (_a) {
        var children = _a.children;
        return sessionToken ? (children) : (_jsx(Navigate, { to: { pathname: "/", search: "" } }));
    };
    return (_jsxs(_Fragment, { children: [_jsx(Layout.Header, { projectTitle: "SEP-24 Reference UI", hasDarkModeToggle: true }), _jsx(Layout.Content, { children: _jsx(Layout.Inset, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(Welcome, {}) }), _jsx(Route, { path: "/start", element: _jsx(Start, { token: token, callback: handleStartSession }) }), _jsx(Route, { path: "/kyc", element: _jsx(ProtectedRoute, { children: _jsx(Kyc, { type: txnInfo === null || txnInfo === void 0 ? void 0 : txnInfo.kind, sessionToken: sessionToken, callback: handleFinishTransaction }) }) }), _jsx(Route, { path: "/status", element: _jsx(ProtectedRoute, { children: _jsx(Status, { txnInfo: txnInfo, sessionToken: sessionToken }) }) }), _jsx(Route, { path: "/txn", element: _jsx(TxnInfo, { txnId: (_a = searchParams.get("transaction_id")) !== null && _a !== void 0 ? _a : "" }) }), _jsx(Route, { path: "*", element: _jsx(NotFound, {}) })] }) }) }), _jsx(Layout.Footer, {})] }));
};
